import { render, staticRenderFns } from "./EditRecruitingProfileEducation.vue?vue&type=template&id=328d4ad1&scoped=true&"
import script from "./EditRecruitingProfileEducation.vue?vue&type=script&lang=ts&"
export * from "./EditRecruitingProfileEducation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d4ad1",
  null
  
)

export default component.exports